import React from 'react';
import styles from './Table.module.css';

const TableHeader = ({ columns }) => {
  return (
    <thead className={styles.tableHead}>
      <tr className={styles.tableRow}>
        {columns?.map((headCell) => (
          <th
            colSpan={headCell.colSpan}
            flex={headCell.flex}
            key={headCell.field}
            className={styles.tableHeaderCell}
            style={headCell.style}>
            {headCell.label}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
